import { Box, Button } from '@mui/material';

const BlogBreadcrumb = ({ ogTitle, category, label }) => {
  return (
    <Box display="flex" sx={{ color: '#919191', fontWeight: 'bold', justifyContent: 'center', alignItems: 'center' }}>
      <Box display="flex">
        <Box type="span">Guide&nbsp;</Box>
        <Box>/</Box>
      </Box>
      <Box display="flex">
        {ogTitle && (
          <>
            <a style={{ textDecoration: 'none' }} href={`/guide/${category.toLowerCase()}`}>
              <Box type="span">&nbsp;{label ? label : category}&nbsp;</Box>
            </a>
            <Box>/</Box>
          </>
        )}
        {!ogTitle && (
          <a style={{ textDecoration: 'none' }} href={`/guide/${category.toLowerCase()}`}>
            <Box
              type="span"
              sx={{
                background: 'var(--category-color)',
                textTransform: 'uppercase',
                color: '#fff',
                padding: '10px 20px',
                borderRadius: '7px',
                marginLeft: '10px',
              }}>
              &nbsp;{label ? label : category}&nbsp;
            </Box>
          </a>
        )}
      </Box>
      {ogTitle && (
        <Box display="flex">
          <Box type="span" sx={{ color: 'black', textTransform: 'uppercase', padding: '0 10px' }}>
            {ogTitle}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default BlogBreadcrumb;
